import type { TollPreviewDataResponseData } from 'contracts/transport-routes';
import { useTranslation } from 'hooks';
import { Skeleton } from 'components/ui/skeleton';

import { translations } from './translations';
import * as React from 'react';

type Props = {
  tollPreviewData?: TollPreviewDataResponseData;
  loading?: boolean;
}

export const HeaderContent = ({ tollPreviewData, loading }: Props) => {
  const { getTranslation: t } =  useTranslation(translations);

  if (!tollPreviewData || loading) {
    return <HeaderContentSkeleton />
  }

  const {
    origin_city_name,
    origin_uf,
    destination_city_name,
    destination_uf,
    distance,
    duration
  } = tollPreviewData;

  return (
    <div className={'flex flex-row gap-4 w-full'}>
      <div className={'flex flex-col h-11'}>
        <p className={'font-GilroyBold text-[16px]'}>{t('title')}</p>
        <p className={'text-gray-600 font-sans text-xs space-x-2 mt-auto'}>
          <span>{origin_city_name}/{origin_uf}</span>
          <span>{destination_city_name}/{destination_uf}</span>
        </p>
      </div>
      <div className={'flex flex-col h-11 ml-auto'}>
        <p className={'text-gray-600 font-sans text-xs mt-auto'}>
          {t('distance')}
        </p>
        <p className={'font-GilroyBold text-[16px]'}>{distance || '---'}</p>
      </div>
      <div className={'flex flex-col h-11 ml-14'}>
        <p className={'text-gray-600 font-sans text-xs mt-auto'}>
          {t('duration')}
        </p>
        <p className={'font-GilroyBold text-[16px]'}>{duration || '---'}</p>
      </div>
    </div>
  );
};

const HeaderContentSkeleton = () => {
  const { getTranslation: t } =  useTranslation(translations);

  return (
    <div className={'flex flex-row gap-4 w-full'}>
      <div className={'flex flex-col h-11'}>
        <p className={'font-GilroyBold text-[16px]'}>{t('title')}</p>
        <div className={'flex gap-2 mt-auto'}>
          <Skeleton className={'h-4 w-24'} />
          <Skeleton className={'h-4 w-24'} />
        </div>
      </div>
      <div className={'flex flex-col h-11 ml-auto'}>
        <p className={'text-gray-600 font-sans text-xs mt-auto'}>
          {t('distance')}
        </p>
        <p className={''}>
          <Skeleton className={'h-4 w-12'} />
        </p>
      </div>
      <div className={'flex flex-col h-11 ml-14'}>
        <p className={'text-gray-600 font-sans text-xs mt-auto'}>
          {t('duration')}
        </p>
        <div className={''}>
          <Skeleton className={'h-4 w-12'} />
        </div>
      </div>
    </div>
  );
}